import { MESSAGE_TEMPLATE_TYPES, } from "../types/messageTemplate";
export var MESSAGE_TEMPLATES_PARAM = "templates";
/**
 * An unknown value reads as a closed editor: a stale or hand-edited URL must not open the
 * dialog on a template type the user never chose.
 */
export var parseMessageTemplatesParam = function (search) {
    var _a;
    var raw = new URLSearchParams(search).get(MESSAGE_TEMPLATES_PARAM);
    return (_a = MESSAGE_TEMPLATE_TYPES.find(function (type) { return type === raw; })) !== null && _a !== void 0 ? _a : null;
};
export var withMessageTemplatesParam = function (search, type) {
    var params = new URLSearchParams(search);
    if (type) {
        params.set(MESSAGE_TEMPLATES_PARAM, type);
    }
    else {
        params.delete(MESSAGE_TEMPLATES_PARAM);
    }
    return params.toString();
};
